import React from "react";
import { BrowserRouter, Routes,Route } from "react-router-dom";
import Menu from "./Menu/Menu";
import Home from "./HOME/Home";
import About from "./About/About";
import Contact from "./contact/Contact";
import Resume from "./Resume/Resume";
import Portfolio from "./Portfolio/Portfolio";
import Social from "./social/Social";
function App() {
return (
<div>
<BrowserRouter>
    <Menu/>
   
    <Routes>
    <Route path="/" element={<Home/>}></Route>
    <Route path="/About" element={<About/>}></Route>
    <Route path="/Resume" element={<Resume/>}></Route>

    <Route path="/Portfolio" element={<Portfolio/>}></Route>
    <Route path="/Social" element={<Social/>}></Route>
    <Route path="/Contact" element={<Contact/>}></Route>
    </Routes>
   </BrowserRouter>
</div>
)
}
export default App;
